import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssetApi } from './api/asset.api';
import { AuctionAssetApi } from './api/auction-asset.api';
import { AuctionsItemsApi } from './api/auction-item.api';
import { AuctionResultsApi } from './api/auction-result.api';
import { AuctionsApi } from './api/auctions.api';
import { BidsApi } from './api/bid.api';
import { ContentModuleApi } from './api/content-module.api';
import { ContentApi } from './api/content.api';
import { FoundationPartnersApi } from './api/foundation-partner.api';
import { FoundationsApi } from './api/foundations.api';
import { RepeatOffendersApi } from './api/repeat-offenders.api';
import { TeamApi } from './api/team.spi';
import { UsersApi } from './api/users.api';
import { StorageService } from './storage.service';
import { ResourcesApi } from './api/resources.api';
import { AnnouncementApi } from './api/announcement.api';
import { AccountingReportApi } from './api/accounting-report.api';
import { FoundationFulfillmentOptionApi } from './api/foundation-fulfillment-option.api';
import { AgreementsApi } from './api/agreements.api';

@Injectable({ providedIn: 'root' })
export class ApiService {
  users = new UsersApi(this.http, this.storage);
  foundations = new FoundationsApi(this.http, this.storage);
  team = new TeamApi(this.http, this.storage);
  agreements = new AgreementsApi(this.http, this.storage);
  auctions = new AuctionsApi(this.http, this.storage);
  auctionItems = new AuctionsItemsApi(this.http, this.storage);
  assets = new AssetApi(this.http, this.storage);
  auctionAsset = new AuctionAssetApi(this.http, this.storage);
  bids = new BidsApi(this.http, this.storage);
  auctionResults = new AuctionResultsApi(this.http, this.storage);
  contentModule = new ContentModuleApi(this.http, this.storage);
  foundationPartner = new FoundationPartnersApi(this.http, this.storage);
  content = new ContentApi(this.http, this.storage);
  repeatOffender = new RepeatOffendersApi(this.http, this.storage);
  resources = new ResourcesApi(this.http, this.storage);
  announcements = new AnnouncementApi(this.http, this.storage);
  accountingReport = new AccountingReportApi(this.http, this.storage);
  foundationFulfillmentOption = new FoundationFulfillmentOptionApi(this.http, this.storage);

  constructor(public http: HttpClient, public storage: StorageService) {}
}
